import '../styles/home.css';
import woman from '../media/woman.png';

import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

import { BsClipboard2DataFill } from "react-icons/bs";
import { GiPencilBrush } from "react-icons/gi";
import { AiOutlineTeam } from "react-icons/ai";
import { FaBusinessTime } from "react-icons/fa";
import { useState } from "react";
import Navbar from './navbar';
import Footer from './footer';
import Testimonials from './testimonials';
import Clients from './clients';
import Contact from './contact';

//client logo
// import naturals from '../media/clients/naturals.png';


//


function Home(){
  const fadeUpVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.4, ease: "easeOut" },
    }),
  };

  const [activeTab, setActiveTab] = useState("Our Story");

  const content = {
    "Our Story": `Founded by a group of creative professionals with a clear goal, BuildEdge Studios emerged from a shared belief that every brand deserves a unique voice. We began as a small team committed to tailored strategies and have grown into a trusted partner for businesses striving to excel. Our journey is marked by collaboration, perseverance, and innovative campaigns that honor each client’s distinct potential.`,

    "Our Mission": `Our mission is to empower every brand with smart, creative marketing solutions that deliver consistent results. We transform challenges into opportunities by employing strategic, data-informed methods. Through honesty, transparency, and relentless innovation, we aim to provide every client with measurable growth and a distinct competitive edge. We thrive on creating partnerships that make lasting impacts on the business landscape.`,

    "Our Goals": `We set clear, unified goals designed to elevate both our clients and our own team. Our focus is on building enduring relationships, pioneering innovative campaigns, and ensuring every strategy is both effective and sustainable. By continuously monitoring performance with transparent metrics, we aspire to maximize value, drive engagement, and achieve measurable milestones for every project we tackle.`,

    "Our Vision": `We envision a future where every brand realizes its full potential through creative and strategic marketing. BuildEdge Studios will be recognized as a catalyst for transformative success, leading the way in a dynamic marketing landscape. Our forward-thinking approach, combined with a commitment to continuous improvement, aims to set new industry standards and redefine the path to long-term success.`
  };
  const tabs = Object.keys(content);

  const styles = {
    wrapper: {
      padding: '1rem',
      textAlign: 'center',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '1rem',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      marginBottom: '2rem',
    },
    content: {
      maxWidth: '800px',
      margin: '0 auto',
      textAlign: 'center',
      fontSize: '18px',
      lineHeight: '1.5',
      paddingTop: "2%"
    }
  };

  const accordionData = [
    { id: '01', title: 'Digital Solutions', content: [
      'Social Media Marketing',
      'SEO (Search Engine Optimization) & SEM (Search Engine Marketing)',
      'Pay-Per-Click (PPC) Advertising',
      'Influencer Marketing',
      'Email Marketing'
    ] },
    { id: '02', title: 'Marketing Consulting', content: [
      'Brand Strategy Development',
      'Market Research & Analysis',
      'Business Growth Consulting',
      'Public Relations',
      'Brand Management'
    ] },
    { id: '04', title: 'Media Production', content: [
      'Video Production & Editing',
      'Graphic Design & Branding',
      'Ad Campaign Creation',
      'Corporate Presentations'
    ] },
    { id: '05', title: 'Web Development', content: [
      'Custom Website Design',
      'E-commerce Solutions',
      'UI/UX Optimization',
    ] },
    {
      id: '06',
      title: 'Content Writing',
      content: [
        'Blog Writing',
        'Website Content',
        'SEO-Optimized Copywriting',
      ],
    },
  ];
  
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleIndex = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  
  
  
    return (
       <>
        <Navbar/>
        <div>
        <section class="hero">
          <div class="hero-text">
            <motion.h1 custom={0} variants={fadeUpVariant} initial="hidden" animate="visible">
                Welcome to <span className="highlight">BuildEdge Studios</span>
            </motion.h1>
            <motion.h2 custom={1} variants={fadeUpVariant} initial="hidden" animate="visible">
              Your Marketing Partner
            </motion.h2>
            <motion.p custom={2} variants={fadeUpVariant} initial="hidden" animate="visible">
            At BuildEdge Studios, we are the strategic partner behind bold brands. From marketing consulting and digital campaigns to media production, web development, content creation, and strategic planning — we deliver the tools, insights, and fuel growth, drive engagement, and lead businesses to lasting success 🚀
            </motion.p>

            <div class="buttons">
              <motion.div className="buttons" custom={3} variants={fadeUpVariant} initial="hidden" animate="visible">
                <a href="https://wa.me/918139080779?text=Hi%2C%20I%27m%20interested%20in%20a%20free%20consultation." className="btn-primary">
                  <FaWhatsapp size={25}/> Get Free Consultation
                </a>
                <a href="#services" className="btn-secondary">
                  Learn More
                </a>
              </motion.div>
            </div>
          </div>
          <div class="hero-image">
            <img src={woman} alt="Business Woman" />
          </div>
        </section>
      </div>
      <section id="choose">
        <h1>Why Choose <span>Us?</span></h1>
        <br/><br/>
        <div className="choose-container">
          <div>
                <BsClipboard2DataFill size={30} color="#fdb813"/><br/>
                Data-driven<br/>marketing strategies
          </div>
          <div>
                  <GiPencilBrush size={30} color="#fdb813"/><br/>
                  Creative and result-oriented<br/> campaigns
          </div>
          <div>
                  <AiOutlineTeam size={30} color="#fdb813"/><br/>
                  A team of experts in digital<br/> and traditional marketing
          </div>
          <div>
                  <FaBusinessTime size={30} color="#fdb813"/><br/>
                  Custom solutions tailored<br/> to your business needs
                
          </div>
        </div>
    
        <br/><br/>
      </section>
      <section id="about">
        <h1>About <span>Us</span></h1><br/>
        <div style={styles.wrapper}>
      <div style={styles.buttonContainer}>
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`nav-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div style={styles.content}>
        {content[activeTab].split('\n').map((line, index) => (
          <p key={index} style={{ margin: '0.5rem 0' }}>{line}</p>
        ))}
      </div>
    </div>
    
      <br/><br/>
      </section>
      <section id="services">
          <h1><span>Our</span> Services</h1>
          <br/>
          <div className="accordion">
            {accordionData.map((item, index) => (
              <div className={`accordion-item ${activeIndex === index ? 'active' : ''}`} key={index}>
                <div
                  className="accordion-header"
                  onClick={() => toggleIndex(index)}
                >
                  <span>  {item.title}</span>
                  <span className="arrow">{activeIndex === index ? '↗' : '→'}</span>
                </div>
                {item.content && (
                  <div className="accordion-content">
                    <ul>
                      {item.content.map((point, idx) => (
                        <li key={idx}>{point}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
         
          
          <br/><br/>
      </section>
      <Clients/>
      <Testimonials/>
      <Contact/>
          <Footer/>
       </>
    );
}

export default Home;
